import {PaymentMethods, useProvidersQuery} from 'api/generated';
import {unique} from 'lib/utils';

export const usePaymentMethods = (accountId: string): [PaymentMethods[], boolean] => {
  const {data, loading} = useProvidersQuery({variables: {accountId}});
  const paymentMethods =
    data?.providers?.filter((p) => p.enabled && p.paymentMethod).map((p) => p.paymentMethod!) || [];

  return [unique<PaymentMethods>(paymentMethods), loading];
};
